module.exports = __webpack_public_path__ + "9faadc8e3dfd4d9f28063b2ab9dab05a.jpg";